<div class="modal-header" style="padding: 0.5rem;">
    <div class="row" style="width: 100%;">
        <div class="col"></div>
        <div class="col-auto">
            <a [href]="this.ImageDocPath" target="_blank" class="btn btn-outline-primary btn-sm" role="button">Open In
                New Tab</a>
        </div>
        <div class="col-auto">
            <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="text-center">
        <img *ngIf="!common.isPdf(this.ImageDocPath)" [src]="this.ImageDocPath" class="viewimage" />
        <!-- <iframe *ngIf="common.isPdf(this.ImageDocPath)"
            [src]="this.sanitizer.bypassSecurityTrustResourceUrl(this.ImageDocPath)" class="ifreamview"></iframe> -->
        <object [data]="this.sanitizedPdfUrl" type="application/pdf"
            class="ifreamview">
            <p>Your browser does not support PDFs.
                <a [href]="this.ImageDocPath">Download the PDF</a> instead.
            </p>
        </object>
    </div>
</div>